import { render } from "./CrisisManagementHome.vue?vue&type=template&id=f80b9aa4&scoped=true"
import script from "./CrisisManagementHome.vue?vue&type=script&lang=js"
export * from "./CrisisManagementHome.vue?vue&type=script&lang=js"

import "./CrisisManagementHome.vue?vue&type=style&index=0&id=f80b9aa4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f80b9aa4"]])

export default __exports__